import {
    refreshTokenKeyword,
    sessionTokenLsKeyword,
} from '../localStorage/localStorageRepository'
import { useAppStore } from '@/shared/store'

export const logoutUser = () => {
    localStorage.removeItem(sessionTokenLsKeyword)
    localStorage.removeItem(refreshTokenKeyword)
    useAppStore.setState((state) => ({
        ...state,
        isUserLoggedIn: false,
        actualProfile: null,
        devicesLimitExceeded: false,
    }))
}
